/**
 * Ustawia window.__PRERENDER__ = { ready: true, status } gdy strona osiągnie
 * stan gotowości odpowiedni dla prerenderingu (Playwright snapshotter).
 *
 * Użycie:
 *   usePrerenderReady()                        // strona synchroniczna — zawsze 200
 *   usePrerenderReady(!loading)                // fetch bez stanu not-found — 200
 *   usePrerenderReady(!loading, notFound ? 404 : 200)  // fetch z not-found
 *
 * Domyślny status = 200 — strony statyczne i proste nie muszą podawać statusu.
 * isReady = false → flaga NIE jest ustawiana (Playwright czeka dalej).
 * isReady = true  → flaga ustawiana natychmiast, niezależnie od statusu.
 *
 * Sygnał NIE ma wpływu na normalne użytkowanie — ustawienie globalnej
 * zmiennej jest bezkosztowe i nie zmienia żadnego zachowania aplikacji.
 */
import { useEffect } from 'react';

export function usePrerenderReady(isReady: boolean = true, status: number = 200): void {
  useEffect(() => {
    if (isReady) {
      window.__PRERENDER__ = { ready: true, status };
    }
  }, [isReady, status]);
}
